import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    depId = '',
    userId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.myOrgDepUser.removeUser, {
        depId,
        userId,
    }, options);
    if (error) return { error, status };
    return content || {};
};
